import React, { useEffect } from 'react';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import HomePage from '../pages/HomePage';
import ResultPage from '../pages/ResultPage';
import RestaurantPage from '../pages/RestaurantPage';
import { gaPageview } from '../utils/gaUtils';

const Routes: React.FC = () => {
  const loc = useLocation();
  useEffect(() => {
    gaPageview(loc.pathname + loc.search);
  }, [loc]);
  return (
    <Switch>
      <Route path='/' exact component={HomePage} />
      <Route path='/result/:food' component={ResultPage} />
      <Route path='/restaurant/:food' component={RestaurantPage} />
      <Redirect path='*' to='/' />
    </Switch>
  );
};

export default Routes;
